<template>
  <div>
    <b-modal
      ref="createPosition"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h3
        class="modal-title"
        style="color: #9A9A9A !important">
        CREATE POSITION
      </h3>
      <b-row>
        <b-col md="6">
          <b-form-group :class="{'error-input' : $v.data_position.name.$error}">
            <label>Position Name*</label>
            <j-input
              v-model="$v.data_position.name.$model"
              :max-length="255"
              placeholder="Position Name"/>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group :class="{'error-input' : $v.data_position.code.$error}">
            <label>Position Code*</label>
            <j-input
              v-model="$v.data_position.code.$model"
              :max-length="255"
              placeholder="Code"/>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group :class="{'error-input' : $v.data_position.parent.$error}">
            <label>Parent</label>
            <j-single-select
              v-if="defaultParentLoaded"
              v-model="$v.data_position.parent.$model"
              :is-async="true"
              :load-options="loadOptionsParent"
              :default-options="defaultParent"
              placeholder="Select Parent"
              value-format="object"
              label="name"
              search-prompt-text="Type minimum 3 characters to search..."/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            :class="{'error-input' : $v.data_position.divisions.$error}">
            <label>Unit</label>
            <j-single-select
              v-if="defaultUnitLoaded"
              v-model="$v.data_position.divisions.$model"
              :is-async="true"
              :load-options="loadOptionsDivisions"
              :default-options="defaultUnit"
              value-format="object"
              placeholder="Select Unit"
              label="name"
              search-prompt-text="Type minimum 3 characters to search..."/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group
            :class="{'error-input' : $v.data_position.layer.$error}">
            <label>Layer</label>
            <j-single-select
              v-if="defaultLayerLoaded"
              v-model="$v.data_position.layer.$model"
              :is-async="true"
              :load-options="loadOptionsLayer"
              :default-options="defaultLayer"
              value-format="object"
              placeholder="Select Layer"
              label="name"
              search-prompt-text="Type minimum 3 characters to search..."/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn blue m__r--5"
              @click="saveCreatePosition">
              Create
            </b-button>
            <b-button
              class="btn gray"
              @click="closePage">
              Close
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  name: 'JPositionCreate',
  validations: {
    data_position: {
      name: { required },
      code: { required },
      parent: { },
      divisions: {},
      layer: {},
    //   mapping_timesheet_rule: {},
    },
  },
  data() {
    return {
      defaultUnit: [],
      defaultLayer: [],
      defaultParent: [],
      defaultUnitLoaded: false,
      defaultLayerLoaded: false,
      defaultParentLoaded: false,
      title: {
        main_title: 'CREATE POSITION',
      },
      data_position: {
        name: '',
        code: '',
        parent: null,
        divisions: null,
        layer: null,
        // mapping_timesheet_rule: null,
      },
    };
  },
  computed: {
    // prepare data form to hit API
    generateData() {
      const genData = {
        name: this.data_position.name,
        code: this.data_position.code,
        description: '',
        user_company_id: 0,
        // organigram_head_id: this.data_position.parent ? this.data_position.parent.id : null,
        // organigram_head_name: this.data_position.parent ? this.data_position.parent.name : null,
        divisions: [],
        default_rule: false,
        // eslint-disable-next-line
        mapping_timesheet_rule: this.data_position.mapping_timesheet_rule ? this.data_position.mapping_timesheet_rule.id : null,
      };
      if (this.data_position.divisions) {
        // genData.divisions = this.data_position.divisions ?
        //   this.data_position.divisions.map(dataMap => dataMap.id) : [];
        genData.divisions = this.data_position.divisions ? [this.data_position.divisions.id] : [];
      }
      if (this.data_position.layer) {
        genData.position_layer = {
          id: this.data_position.layer.id,
        };
      }
      if (this.data_position.parent) {
        genData.organigram_head_id = this.data_position.parent.id;
      }
      return genData;
    },
  },
  created() {
    this.getListDefaultDivision().then((data) => {
      this.defaultUnit = data;
      this.defaultUnitLoaded = true;
    });
    this.getListLayerDefault().then((data) => {
      this.defaultLayer = data;
      this.defaultLayerLoaded = true;
    });
    this.getListParentDefault().then((data) => {
      this.defaultParent = data;
      this.defaultParentLoaded = true;
    });
  },
  mounted() {
    // show modal when this component mounted
    this.$refs.createPosition.show();
  },
  methods: {
    ...mapActions('jStorePosition', ['createPosition', 'getListDefaultDivision', 'getListLayerDefault', 'getListParentDefault']),

    loadOptionsParent({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: '',
              ascending: true,
              query_type: 'position',
              query: searchQuery,
            },
          };
          this.$store.dispatch('jStorePosition/getListParent', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },
    loadOptionsLayer({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: '',
              ascending: true,
              query: searchQuery,
              query_type: 'name',
            },
          };
          this.$store.dispatch('jStorePosition/getListLayer', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },
    loadOptionsDivisions({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: '',
              ascending: true,
              query: searchQuery,
            },
          };
          this.$store.dispatch('jStorePosition/getListDivisions', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },
    saveCreatePosition() {
      this.$v.data_position.$touch();
      if (!this.$v.data_position.$error) {
        this.createPosition(this.generateData);
        this.closePage();
      }
    },

    closePage() {
      this.$emit('closemodal');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/position/jPositionCreate.vue